import styled from '@emotion/styled';
import { SnackBar } from 'ui/components/elements/SnackBar/SnackBar';
import { useApplicationForm } from './useApplicationForm';
import { useModal } from 'ui/components/screens/modals/useModal';
import { CompanyNameSearch } from 'ui/components/screens/modals/CompanyNameSearch/CompanyNameSearch';
import { TemplateModal } from 'ui/components/screens/modals/TemplateModal/TemplateModal';
import { BuyerEditForm } from 'ui/components/buyer/patterns/BuyerEditForm/BuyerEditForm';
import { mqUser } from 'utils/responsive';

const BgWrapper = styled.div`
    padding: 18px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    text-align: left;
    background-color: #f8f9fd;
    height: auto;
    min-height: calc(100vh - var(--height-pc-header));

    ${mqUser('SP')} {
        padding: 18px 15px;
    }
`;

const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: center;
    margin-bottom: 40px;
`;

const Title = styled.div`
    font-size: var(--font-xx-large);
    color: var(--dark-blue);
    font-weight: 900;
    text-align: center;
`;

const Step = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--dark-blue);
    color: var(--white);
    font-size: var(--font-medium);
    font-weight: 700;
    border-radius: 8px;
    padding: 6px 15px;
    width: fit-content;
`;

export const ApplicationForm: React.FC = () => {
    const {
        user,
        control,
        loading,
        errors,
        areaChoices,
        employeeChoices,
        revenueChoices,
        industryChoices,
        employeeLowerChoices,
        employeeUpperChoices,
        revenueScaleLowerChoices,
        revenueScaleUpperChoices,
        profitLevelLowerChoices,
        profitLevelUpperChoices,
        netAssetsLevelLowerChoices,
        netAssetsLevelUpperChoices,
        purchaseAmountLowerChoices,
        purchaseAmountUpperChoices,
        hasAcquisitionExperienceChoices,
        showSnackbar,
        setShowSnackbar,
        submit,
        setValue,
        watch,
        onCompanySelect,
    } = useApplicationForm();

    const companySearchModal = useModal();
    const templateModal = useModal();

    if (!user) {
        return null;
    }
    console.log(errors);
    const handleSelectTemplate = (text: string) => {
        const currentQuestion = watch('question') || '';
        if (currentQuestion.trim()) {
            setValue('question', currentQuestion + '\n' + text);
        } else {
            setValue('question', text);
        }
    };

    return (
        <BgWrapper>
            {companySearchModal.createModal(
                <CompanyNameSearch
                    onSelect={(company) => onCompanySelect(company)}
                    closeModal={companySearchModal.closeModal}
                />,
                { scrollable: false },
            )}
            {templateModal.createModal(
                <TemplateModal
                    onSelect={handleSelectTemplate}
                    onClose={templateModal.closeModal}
                    companyType="buyer"
                />,
                {
                    keyboard: true,
                    maskClosable: true,
                    onClose: templateModal.closeModal,
                },
            )}
            <SnackBar message="公開しました" open={showSnackbar} setOpen={setShowSnackbar} />
            <TitleContainer>
                <Step>STEP1</Step>
                <Title>企業プロフィールを入力してください</Title>
            </TitleContainer>

            <BuyerEditForm
                user={user}
                control={control}
                loading={loading}
                errors={errors}
                areaChoices={areaChoices}
                employeeChoices={employeeChoices}
                revenueChoices={revenueChoices}
                industryChoices={industryChoices}
                employeeLowerChoices={employeeLowerChoices}
                employeeUpperChoices={employeeUpperChoices}
                revenueScaleLowerChoices={revenueScaleLowerChoices}
                revenueScaleUpperChoices={revenueScaleUpperChoices}
                profitLevelLowerChoices={profitLevelLowerChoices}
                profitLevelUpperChoices={profitLevelUpperChoices}
                netAssetsLevelLowerChoices={netAssetsLevelLowerChoices}
                netAssetsLevelUpperChoices={netAssetsLevelUpperChoices}
                purchaseAmountLowerChoices={purchaseAmountLowerChoices}
                purchaseAmountUpperChoices={purchaseAmountUpperChoices}
                hasAcquisitionExperienceChoices={hasAcquisitionExperienceChoices}
                submit={submit}
                setValue={setValue}
                watch={watch}
                onCompanySelect={onCompanySelect}
                showSnackbar={showSnackbar}
                setShowSnackbar={setShowSnackbar}
            />
        </BgWrapper>
    );
};
